import React from 'react';
import { Input, InputProps } from 'antd';
type GenericSearchProps = {
  value?: string;
  placeholder? : string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
} & InputProps;

const GenericSearch: React.FC<GenericSearchProps> = ({
  value,
  placeholder,
  onChange,
  ...rest
}) => {
  return (
      <Input value={value} placeholder={placeholder} onChange={onChange} {...rest} />
  );
};

export default GenericSearch;
